import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TabBar } from "src/components/tabbar";
import { useNavigate } from "react-router-dom";
import TeamsReport from "./components/teams";
import LearningsReport from "./components/learnings";

import _ from "lodash";
import cx from "classnames";
import styles from "./reports.module.scss";

import userRoleService from "src/services/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";

const CoachingReports: React.FC<object> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  if(!userRoleService.canAccessCoachingReport()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  return (
    <div className={styles.container}>
      <div
        className={cx(styles.tabs, {
          [styles.active]: activeTab,
        })}
      >
        {userRoleService.canAccessCoachingReport() &&
          <div className={cx(styles.tab, { [styles.active]: activeTab == 0 })} onClick={() => handleTabClick(0)}>
            teams
          </div>  
        }
        
        <div className={cx(styles.tab, { [styles.active]: activeTab == 1 })} onClick={() => handleTabClick(1)}>
          learnings
        </div>
      </div>

      {activeTab === 0 && <TeamsReport />}
      {activeTab === 1 && <LearningsReport />}
    </div>
  );
};

export { CoachingReports };
